module.exports = __webpack_public_path__ + "img/nt87-00-82-1.asm.e8b84c66.jpg";